import createReducer from "./createReducer";

import {
	SUPPRESS_SUCCESS_GROWL,
	SUPPRESS_ALL_GROWL,
	FACEBOOK_DSP_INTERNAL_NAME,
	YOUTUBE_DSP_INTERNAL_NAME
} from "utils/constants";
import { GENERIC_PREVIEW_TAB, FEEDS_TAB } from "widgets/modals/creatives/social/Tabs";

export const SOCIAL_ACTIONS = {
	LOAD_DSP_CONNECTIONS_AJAX: "LOAD_DSP_CONNECTIONS_AJAX",
	LOAD_DSP_CONNECTIONS_SUCCESS: "LOAD_DSP_CONNECTIONS_SUCCESS",
	LOAD_DSP_CONNECTIONS_ERROR: "LOAD_DSP_CONNECTIONS_ERROR",

	LOAD_DSP_METADATA_AJAX: "LOAD_DSP_METADATA_AJAX",
	LOAD_DSP_METADATA_SUCCESS: "LOAD_DSP_METADATA_SUCCESS",
	LOAD_DSP_METADATA_ERROR: "LOAD_DSP_METADATA_ERROR",

	LOAD_CTA_AJAX: "LOAD_CTA_AJAX",
	LOAD_CTA_SUCCESS: "LOAD_CTA_SUCCESS",
	LOAD_CTA_ERROR: "LOAD_CTA_ERROR",

	LOAD_FACEBOOK_PAGES_AJAX: "LOAD_FACEBOOK_PAGES_AJAX",
	LOAD_FACEBOOK_PAGES_SUCCESS: "LOAD_FACEBOOK_PAGES_SUCCESS",
	LOAD_FACEBOOK_PAGES_ERROR: "LOAD_FACEBOOK_PAGES_ERROR",

	LOAD_FACEBOOK_PREVIEW_AJAX: "LOAD_FACEBOOK_PREVIEW_AJAX",
	LOAD_FACEBOOK_PREVIEW_SUCCESS: "LOAD_FACEBOOK_PREVIEW_SUCCESS",
	LOAD_FACEBOOK_PREVIEW_ERROR: "LOAD_FACEBOOK_PREVIEW_ERROR",

	LOAD_GOOGLE_LOCALES_AJAX: "LOAD_GOOGLE_LOCALES_AJAX",
	LOAD_GOOGLE_LOCALES_SUCCESS: "LOAD_GOOGLE_LOCALES_SUCCESS",
	LOAD_GOOGLE_LOCALES_ERROR: "LOAD_GOOGLE_LOCALES_ERROR",

	CHANGE_TAB: "CHANGE_TAB",
	CHANGE_PLACEMENT: "CHANGE_PLACEMENT",
	CHANGE_ASPECT_RATIO: "CHANGE_ASPECT_RATIO",
	CHANGE_FB_PLACEMENT: "CHANGE_FB_PLACEMENT",
	RESET_PLACEMENT: "RESET_PLACEMENT",
	RESET_SOCIAL_INFO: "RESET_SOCIAL_INFO",

	BULK_IMPORT_SOCIAL_CREATIVES_AJAX: "BULK_IMPORT_SOCIAL_CREATIVES_AJAX",
	BULK_IMPORT_SOCIAL_CREATIVES_SUCCESS: "BULK_IMPORT_SOCIAL_CREATIVES_SUCCESS",
	BULK_IMPORT_SOCIAL_CREATIVES_ERROR: "BULK_IMPORT_SOCIAL_CREATIVES_ERROR",

	LOAD_FACEBOOK_PLACEMENT_TYPES_AJAX: "LOAD_FACEBOOK_PLACEMENT_TYPES_AJAX",
	LOAD_FACEBOOK_PLACEMENT_TYPES_SUCCESS: "LOAD_FACEBOOK_PLACEMENT_TYPES_SUCCESS",
	LOAD_FACEBOOK_PLACEMENT_TYPES_ERROR: "LOAD_FACEBOOK_PLACEMENT_TYPES_ERROR",

	RESET_BULK_IMPORT_ERRORS:"RESET_BULK_IMPORT_ERRORS",
};

const DEFAULT_GENERIC = {
		value: "ft_aspect_default",
		label: "Default Assets",
	}
	, DEFAULT_FB = {
		value: "MOBILE_FEED_STANDARD",
		label: "Facebook Feeds",
	}
	, DEFAULT_IG = {
		value: "INSTAGRAM_STANDARD",
		label: "Instagram Feeds",
	}
	, DEFAULT_MG = {
		value: "MESSENGER_MOBILE_INBOX_MEDIA",
		label: "Messenger Inbox",
	}
	;


export const initialSocialState = {
	items: [],
	isLoaded: false,
	hasErrorLoading: false,
	metadata: {
		ctas:{
			items:[],
			isLoaded:false,
		},
	},
	preview:{
		_html: null,
		isLoaded: false,
		hasError: false,
		error: null,
	},
	selectedTab: GENERIC_PREVIEW_TAB,
	selectedPlacement: Object.assign({}, DEFAULT_GENERIC),
	selectedAspectRatio: "square",
	facebookPages: {
		isLoading: false,
		hasErrorLoading: false,
		isLoaded: true, /*
			This defaults to true, and is set to false when the fetch request is sent,
			because some parts of the UI may depend on it to stop showing loading spinners,
			but we'll only fetch these under certain conditions.

			e.g. EditPane will show the spinner, but its child, AccountFields, is responsible
			for dispatching the fetch, only if they're needed.
		*/
	},
	pacTypes: {
		isLoaded: false,
		hasError: false,
		facebookPlacements: [],
		aspectRatios: [],
	},
	googleLocales: {
		isLoaded: false,
		hasErrorLoading: false,
		locales: {},
	},
	bulkImportErrors: null,
	facebookPlacementType: FEEDS_TAB,
};

export function resetSocialInfo(){
	return (dispatch) => {
		return dispatch({
			type:SOCIAL_ACTIONS.RESET_SOCIAL_INFO,
		});
	};
}

function clearSocialInfo(state, action){
	return {
		...initialSocialState,
	};
}

export function loadFacebookPreview(libraryId, creativeId, dspConnectionId, format){
	return (dispatch)=>{
		if([libraryId, creativeId, dspConnectionId, format].some(id => !id || (id === -1))){
			return Promise.reject({
				success:false,
				message:"Invalid ID",
			});
		}

		return dispatch({
			type:SOCIAL_ACTIONS.LOAD_FACEBOOK_PREVIEW_AJAX,
			meta: SUPPRESS_ALL_GROWL,
			AJAX:{
				gateway:"int",
				method:'post',
				url:`ui/dsp-connections/${dspConnectionId}/creative-preview`,
				data:{
					creativeLibrary:{ id: parseInt(libraryId) },
					creative:{ id: parseInt(creativeId) },
					format,
			 	},
				success:SOCIAL_ACTIONS.LOAD_FACEBOOK_PREVIEW_SUCCESS,
				error:SOCIAL_ACTIONS.LOAD_FACEBOOK_PREVIEW_ERROR,
			},
		});
	};
}

export function changeTab(newTab, oldTab){
	return (dispatch, getState) => {
		let payload = newTab;
		let facebookPlacementType = getState()?.social?.facebookPlacementType;

		//reset facebookPlacementType on tab change
		if(facebookPlacementType !== FEEDS_TAB) {
			dispatch({
				type: SOCIAL_ACTIONS.CHANGE_FB_PLACEMENT,
				payload: FEEDS_TAB,
			});
		}

		dispatch({
			type:SOCIAL_ACTIONS.CHANGE_TAB,
			payload,
			meta:{
				tracking:{
					type:          "Social",
					eventCategory: "Change Tab",
					eventLabel:    payload?.label || "",
				},
			},
		});

		return Promise.resolve({ success:true, payload });
	};
}

export function changePlacement(selectedOption){
	const defaultOption = { label:"Select", value:'' };
	return (dispatch) => {
		var payload = selectedOption??defaultOption;
		dispatch({
			type:SOCIAL_ACTIONS.CHANGE_PLACEMENT,
			payload,
		});
		return Promise.resolve({ success:true, payload });
	};
}

export function resetPlacement(){
	return (dispatch) => {
		return dispatch({
			type:SOCIAL_ACTIONS.RESET_PLACEMENT,
		});
	};
}

export function bulkImportSocialCreatives(libraryId, formData){
	/*
		`formData` should be a FormData object, with a separate entry for each file,
		all with the same key, `files`.

		Like:
			FormData: [
				{ files: File },
				{ files: File },
			]
	*/

	return (dispatch) => {
		return dispatch({
			type: SOCIAL_ACTIONS.BULK_IMPORT_SOCIAL_CREATIVES_AJAX,
			meta: SUPPRESS_ALL_GROWL,
			AJAX: {
				url:`creative-libraries/${libraryId}/creatives/social/import/async`,
				method: "post",
				headers: { "Content-Type": "multipart/form-data" },
				data: formData,
				success: SOCIAL_ACTIONS.BULK_IMPORT_SOCIAL_CREATIVES_SUCCESS,
				error: SOCIAL_ACTIONS.BULK_IMPORT_SOCIAL_CREATIVES_ERROR,
			},
		});
	};
}

export function resetBulkImportErrors(){
	return (dispatch) =>{
		return dispatch({
			type:SOCIAL_ACTIONS.RESET_BULK_IMPORT_ERRORS,
		});
	};
}

export function loadPACTypes() {
	return (dispatch, getState) => {
		let { isLoaded, hasError } = getState()?.social?.pacTypes || {};
		if(isLoaded && !hasError){
			// These don't change, so if we've successfully loaded already, we don't have to fetch again
			return;
		}

		return dispatch({
			type: SOCIAL_ACTIONS.LOAD_FACEBOOK_PLACEMENT_TYPES_AJAX,
			AJAX: {
				url: "ui/facebook-placement-types",
				success: SOCIAL_ACTIONS.LOAD_FACEBOOK_PLACEMENT_TYPES_SUCCESS,
				error: SOCIAL_ACTIONS.LOAD_FACEBOOK_PLACEMENT_TYPES_ERROR,
			},
			meta:SUPPRESS_ALL_GROWL,
		});
	};
}

export function changeAspectRatio(selectedAspectRatio) {
	return (dispatch) => {
		let payload = selectedAspectRatio || FEEDS_TAB;
		return dispatch({
			type: SOCIAL_ACTIONS.CHANGE_ASPECT_RATIO,
			payload,
		});
	};
}

export function changeFbPlacement(facebookPlacementType) {
	return (dispatch) => {
		let payload = facebookPlacementType || "square";
		return dispatch({
			type: SOCIAL_ACTIONS.CHANGE_FB_PLACEMENT,
			payload,
		});
	};
}

const handlers = {
	[SOCIAL_ACTIONS.LOAD_DSP_CONNECTIONS_SUCCESS]:addSocialConnections,
	[SOCIAL_ACTIONS.LOAD_DSP_METADATA_SUCCESS]:addSocialMetadata,
	[SOCIAL_ACTIONS.LOAD_DSP_METADATA_AJAX]:initSocialMetadata,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PAGES_AJAX]:requestFacebookPages,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PAGES_SUCCESS]:addFacebookPages,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PAGES_ERROR]:facebookPagesError,

	[SOCIAL_ACTIONS.LOAD_CTA_SUCCESS]:initCTAs,
	[SOCIAL_ACTIONS.LOAD_GOOGLE_LOCALES_AJAX]: initGoogleLocales,
	[SOCIAL_ACTIONS.LOAD_GOOGLE_LOCALES_SUCCESS]: successGoogleLocales,
	[SOCIAL_ACTIONS.LOAD_GOOGLE_LOCALES_ERROR]: errorGoogleLocales,

	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PREVIEW_AJAX]:   initFacebookPreview,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PREVIEW_SUCCESS]:successFacebookPreview,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PREVIEW_ERROR]:  errorFacebookPreview,

	[SOCIAL_ACTIONS.CHANGE_TAB]       :changeSelectedTab,
	[SOCIAL_ACTIONS.CHANGE_PLACEMENT] :changeSelectedPlacement,
	[SOCIAL_ACTIONS.CHANGE_ASPECT_RATIO] :changeSelectedAspectRatio,
	[SOCIAL_ACTIONS.CHANGE_FB_PLACEMENT] :changeSelectedFbPlacement,
	[SOCIAL_ACTIONS.RESET_PLACEMENT]  :resetSelectedPlacement,
	[SOCIAL_ACTIONS.RESET_SOCIAL_INFO]:clearSocialInfo,

	[SOCIAL_ACTIONS.BULK_IMPORT_SOCIAL_CREATIVES_AJAX]:initBulkSocialImport,
	[SOCIAL_ACTIONS.BULK_IMPORT_SOCIAL_CREATIVES_SUCCESS]:bulkSocialImportSuccess,
	[SOCIAL_ACTIONS.BULK_IMPORT_SOCIAL_CREATIVES_ERROR]:bulkSocialImportError,

	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PLACEMENT_TYPES_AJAX]: initLoadPACTypes,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PLACEMENT_TYPES_SUCCESS]: successLoadPACTypes,
	[SOCIAL_ACTIONS.LOAD_FACEBOOK_PLACEMENT_TYPES_ERROR]: errorLoadPACTypes,

	[SOCIAL_ACTIONS.RESET_BULK_IMPORT_ERRORS]:initBulkSocialImport,
};

export function loadDSPConnections(libraryId){
	if(!libraryId){
		return Promise.reject({ success:false });
	}

	return (dispatch) => {
		return dispatch({
			type:SOCIAL_ACTIONS.LOAD_DSP_CONNECTIONS_AJAX,
			meta:SUPPRESS_ALL_GROWL,
			AJAX:{
				gateway:"int",
				url:`ui/creative-libraries/${libraryId}/connections`,
				params:{ "filter[dsp.type]": "eq:social" },
				success:SOCIAL_ACTIONS.LOAD_DSP_CONNECTIONS_SUCCESS,
				error:SOCIAL_ACTIONS.LOAD_DSP_CONNECTIONS_ERROR,
			},
		});
	};
}

export function loadGoogleLocales(){
	return (dispatch) => {
		return dispatch({
			type:SOCIAL_ACTIONS.LOAD_GOOGLE_LOCALES_AJAX,
			meta:SUPPRESS_ALL_GROWL,
			AJAX:{
				url: "ui/cta-locales",
				success:SOCIAL_ACTIONS.LOAD_GOOGLE_LOCALES_SUCCESS,
				error:SOCIAL_ACTIONS.LOAD_GOOGLE_LOCALES_ERROR,
			},
		});
	};
}

function initGoogleLocales(state, action){
	return {
		...state,
		googleLocales: {
			locales: {},
			isLoaded: false,
			hasErrorLoading: false,
		},
	};
}

function successGoogleLocales(state, action){
	/*
		We receive the locales in the format:
		locales: [
			{
				id: "en",
				name: "English",
				ctas: [
					{
						id: "LEARN_MORE",
						name: "Learn More",
					}, ...
				],
			}, ...
		]

		We want to be able to fetch CTA lists and locale name by locale id, so we store it as:
		{
			en: {
				name: "English",
				ctas: [
					{
						id: "LEARN_MORE",
						name: "Learn More",
					}
				}, ...
			}
		}
	*/
	const locales = action?.payload?.data?.locales || [];
	const formatted = locales.reduce((prev, locale) => {
		prev[locale.id] = {
			name: locale.name,
			ctas: locale.ctas,
		};
		return prev;
	}, {});

	return {
		...state,
		googleLocales: {
			locales: formatted,
			isLoaded: true,
			hasErrorLoading: false,
		},
	};
}

function errorGoogleLocales(state, action){
	return {
		...state,
		googleLocales: {
			locales: {},
			isLoaded: true,
			hasErrorLoading: true,
		},
	};
}

function filterDuplicateConnections(connections = [], internalNames = []){
	/*
		If an Advertiser has multiple connections for certain platforms, they're configured improperly,
		and we have to invalidate all of those connections.
	*/
	let validConnections = connections;
	internalNames.forEach((internalName) => {
		let nonMatchingConnections = validConnections.filter(connection => connection?.dsp?.internalName !== internalName);
		let numMatchingConnections = validConnections.length - nonMatchingConnections.length;

		if(numMatchingConnections > 1){
			validConnections = nonMatchingConnections;
		}
	});

	return validConnections;
}

function addSocialConnections(state, action){
	let { items = []} = action.payload?.data || {};

	let validConnections = filterDuplicateConnections(items, [FACEBOOK_DSP_INTERNAL_NAME, YOUTUBE_DSP_INTERNAL_NAME]);

	return {
		...state,
		isLoaded:true,
		hasErrorLoading:false,
		items: validConnections,
	};
}

export function loadDSPMetadata(dspId){
	return (dispatch) => {
		return dispatch({
			type:SOCIAL_ACTIONS.LOAD_DSP_METADATA_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX:{
				gateway:"int",
				url:`ui/dsps/${dspId}/metadata`,
				success:SOCIAL_ACTIONS.LOAD_DSP_METADATA_SUCCESS,
				error:SOCIAL_ACTIONS.LOAD_DSP_METADATA_ERROR,
			},
		});
	};
}

function initSocialMetadata(state, action){
	return {
		...state,
		metadata:{
			isLoaded:false,
			hasError:false,
		},
	};
}

function addSocialMetadata(state, action){
	let { data } = action.payload;

	return {
		...state,
		metadata:{
			...state.metadata,
			[data.dsp.id]:{
				dsp:data.dsp,
				...data.data,
			},
			isLoaded:true,
			hasError:false,
		},
	};
}

export function loadCTAs(){
	return (dispatch) => {
		return dispatch({
			type:SOCIAL_ACTIONS.LOAD_CTA_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX:{
				gateway:"int",
				url:"ui/call-to-actions",
				success:SOCIAL_ACTIONS.LOAD_CTA_SUCCESS,
				error:SOCIAL_ACTIONS.LOAD_CTA_ERROR,
			},
		});
	};
}
function initCTAs(state, action){
	return {
		...state,
		metadata:{
			...state.metadata,
			ctas:{
				items:action.payload.data.items,
				isLoaded:true,
				success:true,
			},
		},
	};
}

export function loadFacebookPages(libraryId){
	return (dispatch, getState) => {
		if(!libraryId || libraryId === -1){
			return Promise.reject({ success:false, message:"Invalid Library ID" });
		}

		let currentPages = getState().social?.facebookPages || {};

		// If we already have the data loaded, use it from the store, no need to fetch again
		if(currentPages.libraryId === libraryId && currentPages.isLoaded){
			return Promise.resolve({ success:true, payload: { data: currentPages } });
		}

		return dispatch({
			type:SOCIAL_ACTIONS.LOAD_FACEBOOK_PAGES_AJAX,
			meta: SUPPRESS_ALL_GROWL,
			AJAX:{
				gateway:"int",
				url:`ui/creative-libraries/${libraryId}/facebook-metadata`,
				success:SOCIAL_ACTIONS.LOAD_FACEBOOK_PAGES_SUCCESS,
				error:SOCIAL_ACTIONS.LOAD_FACEBOOK_PAGES_ERROR,
			},
			payload:{ libraryId },
		});
	};
}

function initLoadPACTypes(state) {
	return {
		...state,
		pacTypes: {
			isLoaded: false,
			hasError: false,
			facebookPlacements: [],
			aspectRatios: [],
		},
	};
}

function successLoadPACTypes(state, action) {
	return {
		...state,
		pacTypes: {
			...state.pacTypes,
			hasError: false,
			isLoaded: true,
			...(action.payload?.data || {}),
		},
	};
}

function errorLoadPACTypes(state) {
	return {
		...state,
		pacTypes: {
			...state.pacTypes,
			isLoaded: true,
			hasError: true,
		},
	};
}

function initFacebookPreview(state, action){
	return{
		...state,
		preview:{
			_html:null,
			isLoaded:false,
			hasError:false,
			error:null,
		},
	};
}

function successFacebookPreview(state, action){
	let { data } = action.payload;
	return{
		...state,
		preview:{
			_html:data,
			isLoaded:true,
			hasError:false,
			error:null,
		},
	};
}

function errorFacebookPreview(state, action){
	return{
		...state,
		preview:{
			_html:null,
			isLoaded:true,
			hasError:true,
			error:action.payload?.errorObj,
		},
	};
}

function requestFacebookPages(state, action){
	let { payload } = action;

	return {
		...state,
		facebookPages:{
			libraryId:payload.original.libraryId,
			isLoaded:false,
			isLoading:true,
			hasErrorLoading: false,
		},
	};
}

function addFacebookPages(state, action){
	let { payload } = action;

	return {
		...state,
		facebookPages:{
			libraryId:payload.original.libraryId,
			isLoaded:true,
			isLoading: false,
			hasErrorLoading: false,
			...payload.data.data,
		},
	};
}

function facebookPagesError(state, action){
	let { payload } = action;

	return {
		...state,
		facebookPages:{
			libraryId: payload.original.libraryId,
			isLoaded: false,
			isLoading: false,
			hasErrorLoading: true,
		},
	};
}

function changeSelectedTab(state, action){
	let newTab = action.payload
		, selectedPlacement = DEFAULT_GENERIC
		;

	if(newTab.value === "facebook"){
		selectedPlacement = DEFAULT_FB;
	} else if(newTab.value === "instagram"){
		selectedPlacement = DEFAULT_IG;
	} else if(newTab.value === "messenger"){
		selectedPlacement = DEFAULT_MG;
	}
	return {
		...state,
		selectedTab:action.payload,
		selectedPlacement,
	};
}

function changeSelectedPlacement(state, action){
	return {
		...state,
		selectedPlacement:action.payload,
	};
}

function resetSelectedPlacement(state, action){
	return{
		...state,
		selectedTab: GENERIC_PREVIEW_TAB,
		selectedPlacement:Object.assign({}, DEFAULT_GENERIC),
	};
}

function initBulkSocialImport(state, action){
	return {
		...state,
		bulkImportErrors: null,
	};
}


function bulkSocialImportSuccess(state, action){
	return{
		...state,
		bulkImportErrors:null,
		hasError:false,
	};
}

function bulkSocialImportError(state, action){
	let { errorObj } = action.payload;
	return {
		...state,
		bulkImportErrors:{
			hasError:true,
			errorObj,
		},
	};
}

function changeSelectedAspectRatio(state, action) {
	return {
		...state,
		selectedAspectRatio: action.payload,
	};
}

function changeSelectedFbPlacement(state, action) {
	return {
		...state,
		facebookPlacementType: action.payload,
	};
}

let reducerConfig = {
	typeRoot: "LIBRARIES",
	actionTypes: SOCIAL_ACTIONS,
	actionCreators: {
		loadDSPConnections,
		loadDSPMetadata,
		loadFacebookPages,
		loadFacebookPreview,
		changeTab,
		changePlacement,
		changeAspectRatio,
		changeFbPlacement,
		resetPlacement,
		bulkImportSocialCreatives,
		resetBulkImportErrors,
	},
	initialState: initialSocialState,
	handlers,
};

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const HAND = reducerConfig.handlers;
